export default __webpack_public_path__ + "static/media/section-2-right-1.aad1c3ff.png";